import ImageList from '@material-ui/core/ImageList';
import ImageListItem from '@material-ui/core/ImageListItem';
import { IconLink } from './IconLink';
import { ColumnBreakpoints } from './types';
import { useDynamicColumns } from './useDynamicColumns';
import { IconComponent } from '@backstage/core-plugin-api';

export interface GroupLinksGridListItem {
  href: string;
  text?: string;
  Icon?: IconComponent;
}

interface GroupLinksGridListProps {
  items: GroupLinksGridListItem[];
  cols?: ColumnBreakpoints | number;
}

export function LinksGridList(props: GroupLinksGridListProps) {
  const { items, cols = undefined } = props;
  const numOfCols = useDynamicColumns(cols);

  return (
    <ImageList rowHeight="auto" cols={numOfCols}>
      {items.map(({ text, href, Icon }, i) => (
        <ImageListItem key={i}>
          <IconLink href={href} text={text ?? href} Icon={Icon} />
        </ImageListItem>
      ))}
    </ImageList>
  );
}
